import {
  faFileLines,
  faScrewdriverWrench,
  faServer,
  faStore,
  faUserCog,
  faUserLarge,
} from '@fortawesome/free-solid-svg-icons';
import { headerNames } from './constants';

const parentPath = '/docs';

export const documentationRoutes = {
  documentation: {
    path: `${parentPath}/getting-started`,
    key: 'documentation',
    value: headerNames?.documentation,
    icon: faFileLines,
    QADataTag: 'documentationNav',
    permission: 'admin.dashboard.view',
  },
  gettingStartedDocs: {
    path: `${parentPath}/getting-started`,
    key: 'getting-started',
    value: 'Getting Started',
    QADataTag: 'gettingStartedNav',
    permission: 'admin.dashboard.view',
    icon: faScrewdriverWrench,
  },
  memberToolsDocs: {
    path: `${parentPath}/member-tools`,
    key: 'member-tools',
    value: headerNames?.memberTools,
    QADataTag: 'memberToolsNav',
    permission: 'admin.dashboard.view',
    icon: faUserLarge,
  },
  siteAdministrationDocs: {
    path: `${parentPath}/site-administration`,
    key: 'site-administration',
    value: headerNames?.siteAdministration,
    QADataTag: 'siteAdministrationNav',
    permission: 'admin.dashboard.view',
    icon: faStore,
  },
  salesAdministrationDocs: {
    path: `${parentPath}/sales-administration`,
    key: 'sales-administration',
    value: headerNames?.salesAdministration,
    QADataTag: 'salesAdministrationNav',
    permission: 'admin.dashboard.view',
    icon: faStore,
  },
  hqAdministrationDocs: {
    path: `${parentPath}/hq-access`,
    key: 'hq-access',
    value: headerNames?.hqAccess,
    QADataTag: 'hqAdministrationNav',
    permission: 'admin.dashboard.view',
    icon: faUserCog,
  },
  systemDocs: {
    path: `${parentPath}/system`,
    key: 'system',
    value: headerNames?.system,
    QADataTag: 'systemNav',
    permission: 'admin.dashboard.view',
    icon: faServer,
  },
};
